import { render, staticRenderFns } from "./UserWorkspace.vue?vue&type=template&id=3fce6407&"
import script from "./UserWorkspace.vue?vue&type=script&lang=js&"
export * from "./UserWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./UserWorkspace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports